export const PAGE_DETAILS_SECTION_CONSTANT = {
    ACCESSIBILITY: 'page-details-section-accessibility',
    PRIVACY: 'page-details-section-data-privacy',
    PERFORMANCE: 'page-details-section-page-performance',
    POLICIES: 'page-details-section-policies',
    SEO: 'page-details-section-seo',
};

